import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Menu, MenuItem } from '@material-ui/core';
import { RootState } from 'state/store';
import Loop from '@material-ui/icons/Loop';
import Assistant from '@material-ui/icons/Assistant';
import { AiPrompt } from 'typings';
import { apiRunAiPrompt } from 'state/lead.state';

const AiAssistant = () => {
  const dispatch = useDispatch();
  const aiPrompts = useSelector((state: RootState) => state.lead.aiPrompts);
  const isRunning = useSelector((state: RootState) => state.lead.isRunningAiPrompt);

  const [aiPromptMenuElement, setAiPromptMenuElement] = useState(null);

  // we have no AI prompts, don't render the assistant
  if (!aiPrompts.length) return null;

  const openMenu = (event: any) => {
    if (!isRunning) {
      setAiPromptMenuElement(event.currentTarget);
    }
  };

  const closeMenu = () => {
    setAiPromptMenuElement(null);
  };

  const handleMenuSelection = (aiPrompt: AiPrompt) => () => {
    if (!isRunning) {
      dispatch(apiRunAiPrompt({ aiPromptId: aiPrompt.id }));
    }

    closeMenu();
  };

  return (
    <>
      <div className="ai-assistant" onClick={openMenu}>
        {isRunning ? (
          <>
            <Loop color={'primary'} className={'spin'} /> Generating...
          </>
        ) : (
          <>
            <Assistant color={'primary'} /> AI Assistant
          </>
        )}
      </div>
      <Menu
        anchorEl={aiPromptMenuElement}
        transformOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        open={!!aiPromptMenuElement}
        onClose={closeMenu}
      >
        {aiPrompts.map((aiPrompt) => (
          <MenuItem key={aiPrompt.id} value={aiPrompt.name} onClick={handleMenuSelection(aiPrompt)}>
            <Assistant color={'action'} />
            &nbsp; {aiPrompt.name}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default AiAssistant;
